(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["janak-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const wrapper = document.getElementById('JanakMobileMenu');
    const opener = document.querySelector('.sf-menu-button[aria-controls="JanakMobileMenu"]');
    if (!wrapper || !opener || wrapper.dataset.janakNavigationReady) return;
    wrapper.dataset.janakNavigationReady = 'true';
    const content = wrapper.querySelector('.sf-menu-content');
    const close = wrapper.querySelector('[data-janak-close-menu]');
    const toggles = Array.from(wrapper.querySelectorAll('button[data-toggle-submenu]'));
    let opened = false;
    const open = () => !wrapper.classList.contains('hidden');
    const activePanel = () => {
      const panels = Array.from(wrapper.querySelectorAll('.sf-sub-links:not(.hidden)'));
      return panels.find(panel => panel.querySelector('.back')?.dataset.level === '2' && content.classList.contains('open-level-2'))
        || panels.find(panel => content.classList.contains('open-level-1')) || null;
    };
    const candidates = () => {
      const panel = activePanel();
      const scope = panel || content;
      return [close, ...scope.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')]
        .filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden'
          && (!panel || element === close || element.closest('.sf-sub-links') === panel));
    };
    close.addEventListener('click', () => wrapper.click());
    new MutationObserver(() => {
      const current = open();
      opener.setAttribute('aria-expanded', String(current));
      if (current && !opened) close.focus();
      if (!current && opened && (wrapper.contains(document.activeElement) || document.activeElement === document.body)) opener.focus();
      opened = current;
      toggles.forEach(toggle => {
        const panel = toggle.parentElement.querySelector(':scope > .sf-sub-links');
        const expanded = current && panel && !panel.classList.contains('hidden') && content.classList.contains('open-level-' + toggle.dataset.toggleSubmenu);
        toggle.setAttribute('aria-expanded', String(Boolean(expanded)));
      });
    }).observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });
    wrapper.addEventListener('click', event => {
      const toggle = event.target.closest('button[data-toggle-submenu]');
      const back = event.target.closest('.back');
      if (toggle) {
        const panel = toggle.parentElement.querySelector(':scope > .sf-sub-links');
        setTimeout(() => { if (open() && panel && !panel.classList.contains('hidden')) panel.querySelector('.back')?.focus(); }, 320);
      } else if (back) {
        const panel = back.closest('.sf-sub-links');
        const target = panel?.parentElement.querySelector(':scope > button[data-toggle-submenu]');
        setTimeout(() => { if (open()) target?.focus(); }, 320);
      }
    });
    wrapper.addEventListener('keydown', event => {
      if (!open()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        const panel = activePanel();
        if (panel) panel.querySelector('.back')?.click();
        else close.click();
      } else if (event.key === 'Tab') {
        const elements = candidates();
        const index = elements.indexOf(document.activeElement);
        const next = event.shiftKey ? (index <= 0 ? elements.length - 1 : index - 1) : (index + 1) % elements.length;
        event.preventDefault();
        elements[next]?.focus();
      }
    }, true);
    const desktop = matchMedia('(min-width: 1024px)');
    desktop.addEventListener('change', event => { if (event.matches && open()) close.click(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeSearchAccess = () => {
    const popup = document.querySelector('[data-search-popup]');
    if (!popup || popup.dataset.janakAccessReady) return;
    popup.dataset.janakAccessReady = 'true';
    let opener = null;
    let wasOpen = false;
    const isOpen = () => popup.classList.contains('opacity-100') && !popup.classList.contains('invisible');
    const controls = () => Array.from(document.querySelectorAll('[aria-controls="JanakSearchPopup"]'));
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-open-search-popup]');
      if (trigger) opener = trigger.matches('button') ? trigger : trigger.querySelector('button');
    }, true);
    new MutationObserver(() => {
      const open = isOpen();
      controls().forEach(control => control.setAttribute('aria-expanded', String(open)));
      if (wasOpen && !open && opener?.isConnected && opener.getClientRects().length) opener.focus();
      wasOpen = open;
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    popup.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        popup.querySelector('[data-close-search]')?.click();
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(popup.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex="0"]'))
        .filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSearchAccess, { once: true });
  else initializeSearchAccess();
})();
  } catch(e) { console.error(e); }
})();

})();
